<template>
  <v-layout class="mt-4" row wrap>
    <v-flex xs12>
      <p>{{ date }}</p>
      <p class="subheading">作成者: {{ author }}
        <span>
          ( <a class="primary--text text--darken-1" :href="'https://twitter.com/' + twitter" target="_blank" rel="noopener noreferrer">@{{ twitter }}</a> )
        </span>
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    date: {
      type: String,
      default: ""
    },
    author: {
      type: String,
      default: 'No Name'
    },
    twitter: {
      type: String,
      default: 'noname'
    }
  }
}
</script>